// Hardcoded view groups shown in the View Class filter as shortcuts.
// Each member is matched against view class `view` names (case-insensitive); `aliases`
// cover legacy view classes for the same view (e.g. window-less "Apical_..." rows,
// which most predictions still point at). `window` restricts `view` (not aliases) to one
// window, for views whose name exists under several windows (e.g. Long/Short Axis PV Doppler).
import { IViewClass } from 'models/icardio';

export interface IViewGroupMember {
  view: string;
  window?: string;
  aliases?: string[];
}

export interface IViewGroup {
  label: string;
  members: IViewGroupMember[];
}

export const VIEW_GROUPS: IViewGroup[] = [
  {
    label: 'MR Quantification',
    members: [
      { view: 'CW Doppler of MV Inflow', aliases: ['Apical_CW Doppler of MV Inflow'] },
      { view: 'PW Doppler of LVOT', aliases: ['Apical_PW Doppler of LVOT'] },
      { view: 'PLAX Color on MV' },
      { view: 'A4C Color on MV' },
    ],
  },
  {
    label: 'EchoMeasure V3',
    members: [
      { view: 'CW Doppler of MV Inflow', aliases: ['Apical_CW Doppler of MV Inflow'] },
      { view: 'PLAX Color on MV' },
      { view: 'PLAX Color AV' },
      { view: 'PW Doppler of Desc Ao', aliases: ['Suprasternal_PW Doppler of Desc Ao'] },
      { view: 'CW Doppler of AV Outflow', aliases: ['Apical_CW Doppler of AV Outflow'] },
      { view: 'A4C Color on TV' },
      {
        view: 'CW Doppler of PV Outflow',
        window: 'Short Axis',
        aliases: ['Short Axis_CW Doppler of PV Outflow'],
      },
      {
        view: 'PW Doppler of PV Outflow',
        window: 'Short Axis',
        aliases: ['Short Axis_PW Doppler of PV Outflow'],
      },
    ],
  },
];

export const matchesViewGroupMember = (
  { view, window, aliases = [] }: IViewGroupMember,
  viewClass: Pick<IViewClass, 'view' | 'window'>
): boolean => {
  const vcView = (viewClass.view ?? '').toLowerCase();
  if (vcView === view.toLowerCase()) {
    return !window || (viewClass.window ?? '').toLowerCase() === window.toLowerCase();
  }
  return aliases.some(alias => alias.toLowerCase() === vcView);
};
